import React from 'react';
import WithSection from "components/ScreenSection/WithSection";
import { HomeRequest } from '../component/Home';
import RightSideDetails from '../component/shared/RightSideDetailsRequest';

export function HomeRequests() {
    return (
            <WithSection leftComponent={<HomeRequest />} rightComponent={<RightSideDetails  />} />
    )
}
